export default __webpack_public_path__ + "static/media/animation9.0d083ce1.mp4";